import firebase from '../database/FirebaseConfig';

const db = firebase.firestore();

function removeRowOccurence(uid: string) {
    db.collection('occurrences').doc(uid).delete()
}
export { removeRowOccurence };